export let DELIVERY_METHOD_NAMES;
(function (DELIVERY_METHOD_NAMES) {
  DELIVERY_METHOD_NAMES["FLOATING"] = "FLOATING";
  DELIVERY_METHOD_NAMES["TEASE"] = "TEASE";
  DELIVERY_METHOD_NAMES["BANNER"] = "BANNER";
  DELIVERY_METHOD_NAMES["BROWSER"] = "BROWSER";
  DELIVERY_METHOD_NAMES["SIDEBAR"] = "NOTIFICATION_SIDEBAR";
})(DELIVERY_METHOD_NAMES || (DELIVERY_METHOD_NAMES = {}));
export const DELIVERY_METHOD_CODE_MAP = {
  1: DELIVERY_METHOD_NAMES.TEASE,
  4: DELIVERY_METHOD_NAMES.SIDEBAR,
  6: DELIVERY_METHOD_NAMES.BROWSER,
  8: DELIVERY_METHOD_NAMES.BANNER,
  10: DELIVERY_METHOD_NAMES.FLOATING
};
export let PROFILE_TYPES;
(function (PROFILE_TYPES) {
  PROFILE_TYPES["USER"] = "USER";
  PROFILE_TYPES["COMPANY"] = "COMPANY";
  PROFILE_TYPES["CONTACT"] = "CONTACT";
  PROFILE_TYPES["STRING"] = "STRING";
  PROFILE_TYPES["URL"] = "URL";
})(PROFILE_TYPES || (PROFILE_TYPES = {}));